/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { AppPermissions, Settings, useHasPermission } from "../../../core";
import { SettingsTabNames } from "../props";
import classnames from "classnames";

export interface CustomProps {
  tabName: SettingsTabNames;
  tabChangeHandler: (tabName: SettingsTabNames) => void;
  data: Settings;
}

const LeftMenu: React.FunctionComponent<CustomProps> = (props) => {
  const canManageCheckList = useHasPermission(AppPermissions.ManageCheckList);
  const canUpdateGeneralSettings = useHasPermission(
    AppPermissions.UpdateGeneralSettings
  );
  const canManageServiceAdvisorSettings = useHasPermission(
    AppPermissions.ManageServiceAdvisorSettings
  );
  const canManageBodyShopSettings = useHasPermission(
    AppPermissions.ManageBodyShopSettings
  );

  const canUserbackSettings = useHasPermission(AppPermissions.UserbackSettings);

  const canHolidaySettings = useHasPermission(AppPermissions.HolidaySettings);

  const canWhatsappLeadAssignmentSettings = useHasPermission(
    AppPermissions.WhatsappLeadAssignmentSettings
  );

  const [tabName, setTabName] = React.useState<SettingsTabNames>(
    props.tabName || SettingsTabNames.General
  );
  const setElementActive = (tabValue: SettingsTabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };
  return (
    <div className="col-xl col-lg-3 col-12 bg-gray-100 border-right px-2 py-4 lead-settings-menu">
      <ul className="list-unstyled mb-0 px-0 font-normal font-weight-semibold position-relative lead-settings-list">
        {canUpdateGeneralSettings && (
          <>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.General ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.General)}
              >
                <span className="col py-1 d-block">General Settings</span>
                <span className="col-auto">
                  {(!props.data.currency ||
                    !props.data?.timeZone?.timeZone ||
                    !props.data?.franchiseName) && (
                    <i
                      className="icon-info align-middle"
                      title="Not configured"
                    ></i>
                  )}
                </span>
              </a>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.RequirementSettings ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.RequirementSettings)}
              >
                <span className="col py-1 d-block">Requirement Settings</span>
                {/* <span className="col-auto">
                  {(!props.data.currency ||
                    !props.data?.timeZone?.timeZone ||
                    !props.data?.franchiseName) && (
                    <i
                      className="icon-info align-middle"
                      title="Not configured"
                    ></i>
                  )}
                </span> */}
              </a>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.SMS ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.SMS)}
              >
                <span className="col py-1 d-block">SMS Settings</span>
                <span className="col-auto">
                  {props.data.sms?.account?.configured &&
                    !props.data.sms?.sendSms && (
                      <i
                        className={classnames({
                          "icon-close-round align-middle": true,
                        })}
                        title="Not enabled"
                      ></i>
                    )}
                  {!props.data.sms?.account?.configured && (
                    <i
                      className="icon-info align-middle"
                      title="Not configured"
                    ></i>
                  )}
                </span>
              </a>

              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.Email ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.Email)}
              >
                <span className="col py-1 d-block">Email Settings</span>
                <span className="col-auto">
                  {props.data.email?.configured && !props.data.email?.sendMail && (
                    <i
                      className={classnames({
                        "icon-close-round align-middle": true,
                      })}
                      title="Not enabled"
                    ></i>
                  )}
                  {!props.data.email?.configured && (
                    <i
                      className="icon-info align-middle"
                      title="Not configured"
                    ></i>
                  )}
                </span>
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.Oorjit ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.Oorjit)}
              >
                <span className="col py-1 d-block">Portal API Settings</span>
                <span className="col-auto">
                  {!props.data.oorjit?.apiKey && (
                    <i
                      className="icon-info align-middle"
                      title="Not configured"
                    ></i>
                  )}
                </span>
              </a>
            </li>

            {/* <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.Quotation ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.Quotation)}
              >
                <span className="col py-1 d-block">Proposal Settings</span>
                <span className="col-auto">
                  {!props.data.quotation?.expiry && (
                    <i
                      className="icon-info align-middle"
                      title="Not configured"
                    ></i>
                  )}
                </span>
              </a>
            </li> */}
            {/* <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.Booking ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.Booking)}
              >
                <span className="col py-1 d-block">Booking Settings</span>
                <span className="col-auto">
                  {!props.data.booking?.expiry && (
                    <i
                      className="icon-info align-middle"
                      title="Not configured"
                    ></i>
                  )}
                </span>
              </a>
            </li> */}

            {/* <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.ActivitySettings ? 'active' : ''
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.ActivitySettings)
                }
              >
                <span className="col py-1 d-block">Activity Settings</span>
                <span className="col-auto"></span>
              </a>
            </li> 
            */}

            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.LeadDistribution ? "active" : ""
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.LeadDistribution)
                }
              >
                <span className="col py-1 d-block">Lead Distribution</span>
              </a>
            </li>

            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.CompanyAssignment ? "active" : ""
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.CompanyAssignment)
                }
              >
                <span className="col py-1 d-block">Company Assignment</span>
              </a>
            </li>

            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.LeadActivity ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.LeadActivity)}
              >
                <span className="col py-1 d-block">Lead Activity Settings</span>
              </a>
            </li>

            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.ShortenUrl ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.ShortenUrl)}
              >
                <span className="col py-1 d-block">Shorten Url Settings</span>
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.PDF ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.PDF)}
              >
                <span className="col py-1 d-block">PDF Settings</span>
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.Application ? "active" : ""
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.Application)}
              >
                <span className="col py-1 d-block">Application Settings</span>
              </a>
            </li>
            <li>
            <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.CloudFront ? 'active' : ''
                }`}
                onClick={(e) => setElementActive(SettingsTabNames.CloudFront)}
              >
                <span className="col py-1 d-block">Cloud Front Settings</span>
                <span className="col-auto">
                  {!props.data.cloudFront?.url && (
                    <i
                      className="icon-info align-middle"
                      title="Not configured"
                    ></i>
                  )}
                </span>
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.SocialMediaLinks ? "active" : ""
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.SocialMediaLinks)
                }
              >
                <span className="col py-1 d-block">Social Media Links</span>
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.NotificationSettings
                    ? "active"
                    : ""
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.NotificationSettings)
                }
              >
                <span className="col py-1 d-block">Notification Settings</span>
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.AppNotificationSettings
                    ? "active"
                    : ""
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.AppNotificationSettings)
                }
              >
                <span className="col py-1 d-block">
                  App Notification Settings
                </span>
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.LeadLostApprovalSettings
                    ? "active"
                    : ""
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.LeadLostApprovalSettings)
                }
              >
                <span className="col py-1 d-block">
                  Lead Lost Approval Settings
                </span>
              </a>
            </li>
          </>
        )}
        {/* {canHolidaySettings && (
          <li>
            <a
              href="javascript:void(0)"
              className={`px-2 py-2 d-flex align-items-center rounded ${
                tabName === SettingsTabNames.HolidaySettings ? "active" : ""
              }`}
              onClick={(e) =>
                setElementActive(SettingsTabNames.HolidaySettings)
              }
            >
              <span className="col py-1 d-block">Holiday Settings</span>
            </a>
          </li>
        )}
        {canUserbackSettings && (
          <li>
            <a
              href="javascript:void(0)"
              className={`px-2 py-2 d-flex align-items-center rounded ${
                tabName === SettingsTabNames.UserbackSettings ? "active" : ""
              }`}
              onClick={(e) =>
                setElementActive(SettingsTabNames.UserbackSettings)
              }
            >
              <span className="col py-1 d-block">Userback Settings</span>
            </a>
          </li>
        )}
        {canWhatsappLeadAssignmentSettings && (
          <li>
            <a
              href="javascript:void(0)"
              className={`px-2 py-2 d-flex align-items-center rounded ${
                tabName === SettingsTabNames.WhatsappLeadAssignment
                  ? "active"
                  : ""
              }`}
              onClick={(e) =>
                setElementActive(SettingsTabNames.WhatsappLeadAssignment)
              }
            >
              <span className="col py-1 d-block">
                Whatsapp Lead Assignment Settings
              </span>
            </a>
          </li>
        )}
        {canUpdateGeneralSettings && (
          <>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.PackagePriceCalculation
                    ? "active"
                    : ""
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.PackagePriceCalculation)
                }
              >
                <span className="col py-1 d-block">
                  Package Price Calculation Settings
                </span>
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                className={`px-2 py-2 d-flex align-items-center rounded ${
                  tabName === SettingsTabNames.DeliveryFollowUpGapTime
                    ? "active"
                    : ""
                }`}
                onClick={(e) =>
                  setElementActive(SettingsTabNames.DeliveryFollowUpGapTime)
                }
              >
                <span className="col py-1 d-block">
                  Delivery Follow Up Time Settings
                </span>
              </a>
            </li>
          </>
        )}
        {canManageServiceAdvisorSettings && (
          <li>
            <a
              href="javascript:void(0)"
              className={`px-2 py-2 d-flex align-items-center rounded ${
                tabName === SettingsTabNames.ServiceAdvisorSettings
                  ? "active"
                  : ""
              }`}
              onClick={(e) =>
                setElementActive(SettingsTabNames.ServiceAdvisorSettings)
              }
            >
              <span className="col py-1 d-block">Service Advisor Settings</span>
            </a>
          </li>
        )}
        {canManageBodyShopSettings && (
          <li>
            <a
              href="javascript:void(0)"
              className={`px-2 py-2 d-flex align-items-center rounded ${
                tabName === SettingsTabNames.BodyShopSettings ? "active" : ""
              }`}
              onClick={(e) =>
                setElementActive(SettingsTabNames.BodyShopSettings)
              }
            >
              <span className="col py-1 d-block">Body Shop Settings</span>
            </a>
          </li>
        )}
        {canManageCheckList && (
          <li>
            <a
              href="javascript:void(0)"
              className={`px-2 py-2 d-flex align-items-center rounded ${
                tabName === SettingsTabNames.CheckList ? "active" : ""
              }`}
              onClick={(e) => setElementActive(SettingsTabNames.CheckList)}
            >
              <span className="col py-1 d-block">
                Vehicle Availability Check List
              </span>
            </a>
          </li>
        )} */}
      </ul>
    </div>
  );
};

export default LeftMenu;
